import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Types
import { Profile } from "../../@types/profile";
import { createProfile } from "../profileForm/actions/createProfile";
import { updateProfile } from "../profileForm/actions/updateProfile";
import findProfiles from "./actions/findProfiles";

interface ProfilesListState {
  profilesList: Profile[];
  findStatus: string;
  searchText: string;
}


const initialState = {
  profilesList: [],
  findStatus: "initial",
  searchText: "",
} as ProfilesListState;

const profilesListSlice = createSlice({
  name: "profilesList",
  initialState,
  reducers: {
    setSearchText(state, action: PayloadAction<string>) {
      state.searchText = action.payload || "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(findProfiles.pending, (state) => {
        state.findStatus = "pending";
      })
      .addCase(findProfiles.fulfilled, (state, { payload }) => {
        state.findStatus = "fulfilled";
        state.profilesList = payload;
      })
      .addCase(findProfiles.rejected, (state) => {
        state.findStatus = "rejected";
      })
      .addCase(createProfile.fulfilled, (state, { payload }) => {
        state.profilesList = [...state.profilesList, payload];
      })
      .addCase(updateProfile.fulfilled, (state, { payload }) => {
        state.profilesList = state.profilesList.map((profile) =>
          profile.id === payload.id ? payload : profile
        );
      });
  },
});

export default profilesListSlice.reducer;
